import React from 'react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import Tag from '../Tag'

type RoomStatusProps = {
  status: any
  className?: string
}

const RoomStatus = ({ status, className }: RoomStatusProps) => {
  const { t } = useTranslation()
  const color = () => {
    return (
      {
        false: '#BF6827',
        true: '#63B288'
      }[status] || 'Unknown'
    )
  }

  const getStatusLabel = (status: string): string => {
    return (
      {
        false: 'Não está Gravando',
        true: 'Gravando'
      }[status] || 'Unknown'
    )
  }
  return (
    <Tag color={color()} className={className}>
      {t(getStatusLabel(status))}
    </Tag>
  )
}

export default styled(RoomStatus)``
